import React from 'react';
import PropTypes from 'prop-types';
import AdminSettings from './AdminSetting';

const SystemSettingsCore = props => {
  const { settings, save } = props;
  const values = {
    zones_url: settings.external_urls.zones_url,
    zones_types_url: settings.external_urls.zones_types_url,
    ogn_models: settings.external_urls.ogn_models,
    open_sky_db: settings.external_urls.open_sky_db,
    open_sky_types: settings.external_urls.open_sky_types,
    weather_url: settings.external_urls.weather_url,
    weather_api: settings.api_keys.weather_api,
    email_use_ssl: settings.email.email_use_ssl,
    email_host: settings.email.email_host,
    email_port: settings.email.email_port,
    email_host_user: settings.email.email_host_user,
    email_host_password: settings.email.email_host_password,
    default_from_email: settings.email.default_from_email,
  };

  return (
    <AdminSettings
      key="CORE"
      save={save}
      valuesInit={values}
      settingTitle="CORE"
    />
  );
};

SystemSettingsCore.propTypes = {
  settings: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
};
export default SystemSettingsCore;
